import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { formatPeriodLabel } from '../utils/period';

export interface PeriodSelectorProps {
  /** Selected period, e.g. "2026-06". */
  period: string;
  /** Available periods (newest first), e.g. from getRecentPeriods(). */
  periods: string[];
  onChange: (period: string) => void;
}

/**
 * Shared month/period dropdown. Extracted from CostReportPage so the report
 * pages share one selector (per general/abstract-before-duplicating.md).
 */
const PeriodSelector: React.FC<PeriodSelectorProps> = ({ period, periods, onChange }) => (
  <TextField
    select
    label="Period"
    size="small"
    value={period}
    onChange={(e) => onChange(e.target.value)}
    sx={{ minWidth: 200 }}
    inputProps={{ 'data-testid': 'period-select' }}
  >
    {periods.map((p) => (
      <MenuItem key={p} value={p}>
        {formatPeriodLabel(p)}
      </MenuItem>
    ))}
  </TextField>
);

export default PeriodSelector;
